import { render } from "./anti_money_laundering.html?vue&type=template&id=5198df57&external"
import script from "./anti_money_laundering.js?vue&type=script&lang=js&external"
export * from "./anti_money_laundering.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__